import { render } from "./Link.vue?vue&type=template&id=45ad9753"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"
script.render = render

export default script